import * as actions from './actions';
import { withForm } from './withForm';
/**
 * Creates new Pilet API extensions for enhancing forms.
 */
export function createFormsApi(config = {}) {
    return (context) => {
        context.defineActions(actions);
        context.dispatch((state) => ({
            ...state,
            forms: {},
        }));
        return {
            createForm(options) {
                return (component) => withForm(component, options);
            },
        };
    };
}
//# sourceMappingURL=create.js.map